import { render, staticRenderFns } from "./currency-based-contract.vue?vue&type=template&id=536c01ae"
import script from "./currency-based-contract.vue?vue&type=script&lang=js"
export * from "./currency-based-contract.vue?vue&type=script&lang=js"
import style0 from "./currency-based-contract.vue?vue&type=style&index=0&id=536c01ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports